import { getBaseApiUrl, getBasicAuthKey } from './constants'

export const fetchAPList = async (filter) => {
  const method = '/api/assistant_prompt/list'
  const params = { filter: filter }
  const url = `${getBaseApiUrl()}${method}?${new URLSearchParams(params).toString()}`
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Basic ' + getBasicAuthKey(),
    },
  })
  const json = await response.json()
  if (json.error) {
    throw new Error(json.error)
  }
  if (!json.result) {
    throw new Error('fetchData: no json.result')
  }
  return json.result
}

export const fetchLogs = async (data) => {
  console.log('fetchLogs: data=', data)
  const method = '/api/logs/list'
  const url = `${getBaseApiUrl()}${method}`
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getBasicAuthKey(),
    },
    body: JSON.stringify(data),
  })
  if (!response.ok) {
    const errorMessage = await response.text()
    throw new Error(`Error ${response.status}: ${errorMessage}`)
  }
  const json = await response.json()
  if (json.error) {
    throw new Error(json.error)
  }
  if (!('result' in json)) {
    throw new Error('fetchLogs: no json.result')
  }
  console.log('fetchLogs: json=', json)
  return json.result
}

export const fetchLogGroups = async () => {
  const method = '/api/logs/list_log_groups'
  const url = `${getBaseApiUrl()}${method}`
  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: getBasicAuthKey(),
    },
  })
    .then((response) => response.json())
    .then((data) => data.result)
}

export const login = async (user) => {
  const method = '/api/user/login'
  const url = `${getBaseApiUrl()}${method}`
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(user),
  })
  return await response.json()
}
